export default {
    list: {
        title: 'Devices',
        empty: 'No devices',
        cols: {
            name: 'Name',
            username: 'Username'
        }
    },
    filter: {
        search: 'Search (name or username)'
    },
    actions: {
        newDevice: '+ New device'
    },
    form: {
        name: 'Name',
        username: 'Login name',
        password: 'Password',
        passwordHint: 'Leave blank to keep current password'
    },
    confirm: {
        deleteTitle: 'Delete device?',
        deleteBody: 'Really delete device "{name}"?',
        bulkDeleteTitle: 'Delete selected devices?',
        bulkDeleteBody: 'Really delete {n} devices?',
        unsavedChanges: 'You have unsaved changes. Close anyway?'
    },
    bulk: {
        selected: '{n} selected',
        deleteSelected: 'Delete selected',
        deleteResult: '{ok} deleted, {failed} failed'
    },
    toast: {
        saved: 'Device saved',
        deleted: 'Device deleted'
    },
    qr: {
        title: 'Device login QR',
        load: 'Load QR',
        addToClipboard: 'Add to clipboard',
        added: 'Added to clipboard'
    }
}
